import * as React from 'react'

export default class Chat extends React.Component {
    public render() {
        return (
            <a href="https://wa.me/8618926298211" target="_blank" className="whatsapp">
            	<img src="https://zt.ibuychem.com/cms/en/WhatsApp.png" alt="" />
            </a>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/shop_en/common/chat/index.tsx